<template>
  <h4>Major Sponsors</h4>
  <div>
    <a href="http://sydney.edu.au/perkins/" target="_blank" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/USydney.png"
        alt="University of Sydney"
        title="University of Sydney" />
      <img v-else src="./img/USydney-darkMode.png" alt="University of Sydney" title="University of Sydney" />
    </a>
    <a href="https://www.garvan.org.au/" target="_blank" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Garvan.png"
        alt="Garvan Institute"
        title="Garvan Institute" />
      <img v-else src="./img/Garvan-darkMode.png" alt="Garvan Institute" title="Garvan Institute" />
    </a>
    <a href="https://www.vividsydney.com/" target="_blank" rel="nofollow">
      <img src="./img/vivid.png" alt="Vivid Sydney" title="Vivid Sydney" />
    </a>
    <a href="https://www.data61.csiro.au/" target="_blank" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Data61.png"
        alt="Data61-CSIRO"
        title="Data61-CSIRO" />
      <img v-else src="./img/Data61-darkMode.png" alt="Data61-CSIRO" title="Data61-CSIRO" />
    </a>
    <a href="http://ianpotter.org.au" target="_blank" rel="nofollow">
      <img src="./img/Ian_Potter_Foundation.png" alt="Ian Potter Foundation" title="Ian Potter Foundation" />
    </a>
  </div>
  <h4>Event Sponsors</h4>
  <div>
    <a href="http://www.nvidia.com/" target="_blank" rel="nofollow">
      <img v-if="displayMode === 'lightMode'" src="./img/NVIDIA-lightMode.png" alt="NVIDIA" title="NVIDIA" />
      <img v-else src="./img/NVIDIA-darkMode.png" alt="NVIDIA" title="NVIDIA" />
    </a>
    <a href="http://www.emblaustralia.org/" target="_blank" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/EMBL-Australia.png"
        alt="EMBL-Australia"
        title="EMBL-Australia" />
      <img v-else src="./img/EMBL-Australia-darkMode.png" alt="EMBL-Australia" title="EMBL-Australia" />
    </a>
    <a href="http://www.autodesk.com/" target="_blank" rel="nofollow">
      <img
        v-if="displayMode === 'lightMode'"
        src="./img/Autodesk.png"
        alt="Autodesk"
        title="Autodesk"
        class="autodesk" />
      <img v-else src="./img/Autodesk-darkMode.png" alt="Autodesk" title="Autodesk" class="autodesk" />
    </a>
  </div>
  <h4>Affiliations</h4>
  <div>
    <a href="http://www.iscb.org/" rel="nofollow">
      <img src="./img/ISCB.jpeg" alt="ISCB" title="ISCB" />
    </a>
  </div>
  <h4 id="why">About VIZBI Sponsorship</h4>
  <p>
    VIZBI is an international conference series on Visualizing Biological Data that has alternated
    annually between the European Molecular Biology Laboratory in Heidelberg, Germany, and the Broad
    Institute of MIT and Harvard in Cambridge MA, USA. In 2017, for the first time, VIZBI came to
    Sydney, Australia.
  </p>
  <p>
    VIZBI 2017 offered opportunities to promote organisations engaged with either data visualisation
    or the life sciences. Sponsors gained exposure in a community that includes some of the most
    knowledgeable researchers and professionals working in biological data visualisation. Between
    130&ndash;350 scientists, software developers, medical professionals, illustrators and designers
    from around the world attended VIZBI 2017. Sponsor brands were advertised alongside talks from
    21 invited speakers, and when videos and posters from VIZBI 2017 were published on the main
    VIZBI site, which is accessed by over 3,000 life scientists each month.
  </p>
  <p>
    If you are interested in future sponsorship opportunities, please download the
    <a href="/2017/Opportunities.pdf" target="_blank">VIZBI 2017 Sponsorship form</a> or
    contact us at <Email to="vizbi-contact" />.
  </p>
</template>

<script setup>
import Email from "@/components/Email.vue";
import {inject} from "vue";
const displayMode = inject("displayMode");
</script>

<style scoped>
img.autodesk {
  max-height: calc(3.3rem * 0.6);
}
</style>
